@if (content.faqValues.length > 0) {
  <article class="mb-8">
    <h2 class="typo-h4 mb-2">{{ content.title }}</h2>
    <parkour-accordion
      [items]="content.faqValues"
      [titleTemplate]="titleTemplate"
      [contentTemplate]="contentTemplate"
    >
      <ng-template #titleTemplate let-item="item">
        {{ item.question }}
      </ng-template>
      <ng-template #contentTemplate let-item="item">
        <div [innerHTML]="item.answer" class="wysiwyg"></div>
        @if (item.image && item.image.fullUrl) {
          <parkour-image [alt]="item.image.alt || ''" [src]="item.image.fullUrl" />
        }
        @if (item.video && item.video.url && item.video.type) {
          @if (item.video.title) {
            <p class="typo-h4">{{ item.video.title }}</p>
          }
          <parkour-video-content [content]="mapVideo(item)" />
        }
      </ng-template>
    </parkour-accordion>
  </article>
}
